<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import { getLanguage } from '@/helpers/language-helper'
import { generateBreadcrumbsForUrl } from '@/services/navigationService'
import { __ } from '@/utils/utils'

defineProps({
  title: String,
  subTitle: String,
  withBreadcrumbs: {
    type: Boolean,
    default: true
  }
})
const route = useRoute()

const breadcrumbs = ref<any>([])

const lang: string =
  getLanguage() !== '' && getLanguage() !== 'undefined' && getLanguage() !== 'en'
    ? getLanguage() + '/'
    : ''

onMounted(async () => {
  breadcrumbs.value = await generateBreadcrumbsForUrl(
    'trade-with-us' as string,
    route.params.menu_second as string
  )
})

const siteUrl =`${document.location.origin}/`
</script>
<template>
  <div class="bg-black">
    <div class="lg:pt-10 lg:pl-30 lg:pb-[141px] pb-20 flex flex-col lg:items-start items-center">
      <div
        v-if="withBreadcrumbs"
        class="gap-[2px] flex self-start lg:pl-0 pl-[10px] lg:pt-0 pt-[20px]"
      >
        <a class="text-red-150" :href="`${siteUrl}${lang}`">{{ __('Home') }}</a>
        <span class="text-white">></span>
        <a
          v-if="
            typeof breadcrumbs[1]?.url !== 'undefined' && typeof breadcrumbs[0]?.url !== 'undefined'
          "
          :href="`${siteUrl}${lang}${breadcrumbs[0]?.url}/${breadcrumbs[1]?.url}/`"
          class="text-red-150"
        >
          {{ breadcrumbs[0]?.title }}
        </a>
        <span class="text-white">></span>
        <a
          v-if="
            typeof breadcrumbs[1]?.url !== 'undefined' && typeof breadcrumbs[0]?.url !== 'undefined'
          "
          :href="`${siteUrl}${lang}${breadcrumbs[0]?.url}/${breadcrumbs[1]?.url}/`"
          class="text-white pointer-events-none"
          >{{ breadcrumbs[1]?.title }}</a
        >
      </div>
      <h1
        class="text-white lg:mt-[101px] mt-[37px] lg:h1-bold h3-bold self-center lg:self-start text-center lg:text-start"
        v-html="title"
      ></h1>
      <div
        class="self-center text-white lg:h5-bold nav lg:self-start lg:mt-[10px] mt-[8px] text-center"
        v-html="subTitle"
      ></div>
    </div>
  </div>
</template>
